import AnimateOnScroll from "../AnimateOnScroll";

interface CardGridItem {
  title: string;
  description: string;
  image?: string;
}

interface CardGridSectionProps {
  heading: string;
  items: CardGridItem[];
}

const CardGridSection = ({ heading, items }: CardGridSectionProps) => {
  return (
    <section className="bg-secondary/40 px-6 py-20 md:py-28">
      <div className="mx-auto max-w-6xl">
        <AnimateOnScroll>
          <h2 className="text-center text-3xl font-bold md:text-4xl">{heading}</h2>
        </AnimateOnScroll>
        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item, i) => (
            <AnimateOnScroll
              key={i}
              animation="animate-scale-in"
              delay={`delay-${(i + 1) * 100}`}
            >
              <div className="group h-full overflow-hidden rounded-2xl bg-card shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1">
                {item.image && (
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                      width={400}
                      height={300}
                    />
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-lg font-bold">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground font-body">
                    {item.description}
                  </p>
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardGridSection;
